import { z } from 'zod';

export const getUserDetailsSchema = z.object({
  id: z.string(),
  userName: z.string(),
  name: z.string(),
  mwUserTypeID: z.string(),
  userRoles: z.array(
    z.object({
      id: z.string(),
      isActive: z.boolean(),
      userID: z.string(),
      roleID: z.string(),
      deleted: z.boolean(),
    })
  ),

  userCompanySites: z.array(
    z.object({
      id: z.string(),
      userID: z.string(),
      companySiteID: z.string(),
      deleted: z.boolean(),
    })
  ),
  isActive: z.boolean(),
  isAdmin: z.boolean(),
  isFromManager: z.boolean(),
  eMail: z.string().optional(),
  phone1: z.string().optional(),
});

export type GetUsersResponse = z.infer<typeof getUserDetailsSchema>;
